import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const CardBottomMarginContainer = styled.div<React.CSSProperties>`
  height: ${12 * Screen.widthRatio}px;
  left: ${24 * Screen.widthRatio}px;
  width: ${302 * Screen.widthRatio}px;
  margin-top: ${12 * Screen.widthRatio}px;
`;

export default CardBottomMarginContainer;
